import React from 'react';
import s from './Heading.styles';
import { withMotion } from '@hoc/WithMotion';
const Heading = ({ children, className, semantic = 'h1', visual, lineAfter, inView, }) => {
    const showLine = React.useMemo(() => (inView === undefined ? lineAfter : inView ? lineAfter : false), [inView, lineAfter]);
    return (React.createElement(React.Fragment, null,
        React.createElement(s.Heading, { className: className, as: semantic, visual: visual },
            React.createElement("span", null, children),
            lineAfter && React.createElement(s.Line, { showLine: showLine }))));
};
export default withMotion(Heading);
